import { render } from "./DashboardShell.vue?vue&type=template&id=bf85375e&scoped=true"
import script from "./DashboardShell.vue?vue&type=script&lang=js"
export * from "./DashboardShell.vue?vue&type=script&lang=js"

import "./DashboardShell.vue?vue&type=style&index=0&id=bf85375e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf85375e"]])

export default __exports__